module.exports = function() {
  return new Worker("/" + "assets/download.worker.c489c0fd75354d718cf0.js");
};